import React from 'react'

import { ButtonProps } from 'rebass'

import { useSTheme } from 'styles/theme'
import { useTranslation } from 'i18n'
import { FButtonTypeEnum } from '../constants'
import FButton from '..'

export type FButtonProps = ButtonProps

interface Props {
    onClick: () => void
}

const FButtonPrevious: React.FC<Props> = (props: Props) => {
    const theme = useSTheme()
    const { t } = useTranslation(window.LANG_NS)

    const fontFamily = theme.fontsV2[window.ORGANIZATION.name]?.body || theme.fontsV2.default

    return (
        <FButton
            type="button"
            buttonType={FButtonTypeEnum.Link}
            googleIcon={'arrow_back'}
            textStyle={{
                fontFamily: fontFamily,
                textAlign: 'left',
                padding: 0,
                fontWeight: '700',
            }}
            onClick={props.onClick}
            ga4_key={t('previous', { lang: 'en' })}
        >
            {t('previous')}
        </FButton>
    )
}

export default FButtonPrevious
